module.exports = __webpack_public_path__ + "static/img/image@2x (12).9e8d4df4.png";